import { render, staticRenderFns } from "./PcErrorAlertReskinned.vue?vue&type=template&id=c5212d46"
import script from "./PcErrorAlertReskinned.vue?vue&type=script&lang=js"
export * from "./PcErrorAlertReskinned.vue?vue&type=script&lang=js"
import style0 from "./PcErrorAlertReskinned.vue?vue&type=style&index=0&id=c5212d46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
